import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { fruits } from '../data/fruits';
import FruitCard from '../components/FruitCard';
import './SearchPage.css';

const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q')?.toLowerCase() || '';

  const searchResults = fruits.filter(fruit => {
    const nameMatch = fruit.name.toLowerCase().includes(query);
    const aliasMatch = fruit.alias.toLowerCase().includes(query);
    const benefitMatch = fruit.benefits.some(b => b.category.toLowerCase().includes(query) || b.description.toLowerCase().includes(query));
    return nameMatch || aliasMatch || benefitMatch;
  });

  return (
    <div className="search-page">
      <h1>搜索结果</h1>
      <p className="search-query">您搜索的是: "{query}"</p>

      {searchResults.length > 0 ? (
        <div className="fruit-grid">
          {searchResults.map(fruit => (
            <FruitCard key={fruit.id} fruit={fruit} />
          ))}
        </div>
      ) : (
        <p className="no-results">没有找到相关的搜索结果。</p>
      )}
    </div>
  );
};

export default SearchPage;
